import React from "react";
import { Box, Button, Typography, Container, IconButton } from "@mui/material";
import { motion } from "framer-motion";

// IMPORTANTE: Cambio de imagen según tu solicitud
import fondoChica from "../static/media/fondo_chica.webp";

const MotionBox = motion(Box);
const MotionButton = motion(Button);

const benefits = [
  "Implementación incluida",
  "Soporte técnico continuo",
  "Capacitación guiada",
];

// Redes sociales integradas
const socialLinks = [
  {
    name: "WhatsApp",
    url: "https://api.whatsapp.com/send/?phone=593985092679&type=phone_number&app_absent=0",
    path: "M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51h-.57c-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z",
  },
  {
    name: "Facebook",
    url: "https://www.facebook.com/profile.php?id=61573025660996&locale=es_LA",
    path: "M14 13.5h2.5l1-4H14v-2c0-1.03 0-2 2-2h1.5V2.14c-.326-.043-1.557-.14-2.857-.14C11.928 2 10 3.657 10 6.7v2.8H7v4h3V22h4v-8.5z",
  },
  {
    name: "Instagram",
    url: "https://www.instagram.com/drsolucionesinformaticas?igsh=MTluMnV1dm0zdmVhcQ%3D%3D",
    path: "M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z",
  },
  {
    name: "TikTok",
    url: "https://www.tiktok.com/@dr_solucionesif?_r=1&_t=ZM-91LVbk8h448",
    path: "M12.525.02c1.31-.02 2.61-.01 3.91.04.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.12-3.44-3.17-3.64-5.41-.02-.53-.04-1.06-.04-1.59.04-1.31.39-2.62 1.05-3.75 1.13-2 3.26-3.42 5.56-3.57.51-.04 1.02-.04 1.54-.04v4.06c-.46-.02-.92-.04-1.38.04-.98.13-1.92.74-2.45 1.58-.62 1.03-.68 2.37-.1 3.44.57 1.1 1.73 1.88 2.98 1.92 1.18.06 2.34-.37 3.14-1.18.73-.77 1.1-1.84 1.05-2.92-.05-4.22-.02-8.45-.04-12.67-.01-1.58-.02-3.16-.01-4.74z",
  },
];

const CtaBanner = () => {
  return (
    <Box
      component="section"
      id="cta-section"
      sx={{
        py: { xs: 8, md: 12 },
        background: "linear-gradient(180deg,#ffffff 0%,#f7faff 0%)",
        overflow: "hidden",
      }}
    >
      <Container maxWidth="xl">
        <MotionBox
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          sx={{
            position: "relative",
            overflow: "hidden",
            borderRadius: "36px",
            border: "1px solid rgba(14,165,233,.10)",
            boxShadow: "0 30px 80px rgba(13,93,181,.12)",
            minHeight: { xs: "auto", md: "520px" }, // Altura base

            // LA IMAGEN AHORA ES EL FONDO DEL CONTENEDOR
            backgroundImage: `url(${fondoChica})`,
            backgroundSize: "cover",
            backgroundPosition: { xs: "center", md: "center right" }, // Ajusta la posición de la chica
            backgroundRepeat: "no-repeat",
          }}
        >
          {/* Banda conectada con Hero */}
          <Box
            sx={{
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              height: "8px",
              background:
                "linear-gradient(90deg,#1A2B4A 0%,#0D5DB5 45%,#0EA5E9 100%)",
              zIndex: 3,
            }}
          />

          {/* OVERLAY PARA GARANTIZAR LECTURA */}
          {/* Crea un fundido de blanco a transparente para que el texto siempre se lea */}
          <Box
            sx={{
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,

              zIndex: 1,
            }}
          />

          <Box
            sx={{
              position: "relative",
              zIndex: 2,
              px: { xs: 3, md: 7 },
              py: { xs: 6, md: 8 },
              display: "flex",
              alignItems: "center",
              height: "100%", // Ocupa toda la altura disponible
            }}
          >
            {/* ─── COLUMNA DE TEXTO Y BOTONES ─── */}
            <Box sx={{ maxWidth: { xs: "100%", md: "550px", lg: "650px" } }}>
              <Typography
                component="h2"
                sx={{
                  fontWeight: 700,
                  color: "#1A2B4A",
                  lineHeight: 1.05,
                  letterSpacing: "-.04em",
                  fontSize: { xs: "2.2rem", md: "3.5rem", lg: "4rem" },
                }}
              >
                Tu operación, lista
                <br />
                para el{" "}
                <Box
                  component="span"
                  sx={{
                    background: "linear-gradient(135deg,#0D5DB5,#0EA5E9)",
                    WebkitBackgroundClip: "text",
                    WebkitTextFillColor: "transparent",
                  }}
                >
                  siguiente nivel
                </Box>
              </Typography>

              <Typography
                sx={{
                  mt: 3,
                  color: "#475569",
                  fontSize: { xs: "1rem", md: "1.15rem" },
                  lineHeight: 1.8,
                  maxWidth: 600,
                  fontWeight: 500, // Un poco más de peso para que no se pierda en el fondo
                }}
              >
                Nuestro equipo te acompaña desde el primer día: configuración,
                capacitación y soporte incluidos. Empieza a facturar y controlar
                tu negocio sin complicaciones ni costos ocultos.
              </Typography>

              {/* Beneficios */}
              <Box
                sx={{
                  mt: 4,
                  display: "grid",
                  gridTemplateColumns: {
                    xs: "1fr",
                    sm: "repeat(2,1fr)",
                    lg: "repeat(3,1fr)",
                  },
                  gap: 2,
                  maxWidth: 760,
                }}
              >
                {benefits.map((item) => (
                  <Box
                    key={item}
                    sx={{
                      p: 1.5,
                      borderRadius: "14px",
                      background: "rgba(255,255,255,0.85)", // Cristalizado
                      backdropFilter: "blur(4px)",
                      border: "1px solid rgba(13,93,181,.15)",
                      boxShadow: "0 8px 20px rgba(13,93,181,.05)",
                      display: "flex",
                      gap: 1.5,
                      alignItems: "center",
                    }}
                  >
                    <Box
                      sx={{
                        width: 32,
                        height: 32,
                        borderRadius: "8px",
                        background: "linear-gradient(135deg,#0D5DB5,#2563EB)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        color: "#fff",
                        fontWeight: 700,
                        flexShrink: 0,
                      }}
                    >
                      ✓
                    </Box>
                    <Typography
                      sx={{
                        color: "#1A2B4A",
                        fontWeight: 750,
                        fontSize: "0.9rem",
                      }}
                    >
                      {item}
                    </Typography>
                  </Box>
                ))}
              </Box>

              {/* Contenedor del Botón y Redes Sociales */}
              <Box sx={{ mt: 5 }}>
                <MotionButton
                  component="a"
                  href="https://api.whatsapp.com/send/?phone=593985092679&text=Hola,%20quisiera%20agendar%20una%20demostraci%C3%B3n%20de%20FactuSysDR"
                  target="_blank"
                  rel="noopener noreferrer"
                  whileHover={{ y: -4, scale: 1.02 }}
                  whileTap={{ scale: 0.97 }}
                  variant="contained"
                  sx={{
                    width: { xs: "100%", sm: "auto" },
                    py: { xs: 2, md: 2.2 },
                    px: { xs: 4, md: 5 },
                    borderRadius: "16px",
                    textTransform: "none",
                    fontWeight: 750,
                    fontSize: { xs: "1.05rem", md: "1.2rem" },
                    letterSpacing: "0.01em",
                    color: "#fff",
                    background:
                      "linear-gradient(135deg,#2C5FBE 0%,#1A3D8F 100%)",
                    boxShadow: "0 15px 35px rgba(26,61,143,0.4)",
                    border: "2px solid rgba(255,255,255,0.2)",
                    "&:hover": {
                      background:
                        "linear-gradient(135deg,#214A96 0%,#162E6B 100%)",
                      boxShadow: "0 20px 45px rgba(26,61,143,0.5)",
                    },
                  }}
                >
                  Agenda una demostración
                </MotionButton>

                {/* Sección de Redes Sociales Integrada */}
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 2,
                    mt: 3,
                    flexWrap: "wrap",
                  }}
                >
                  <Typography
                    sx={{
                      color: "#475569",
                      fontWeight: 700,
                      fontSize: "0.95rem",
                    }}
                  >
                    Conéctate con nosotros:
                  </Typography>
                  <Box sx={{ display: "flex", gap: 1.5 }}>
                    {socialLinks.map((social) => (
                      <IconButton
                        key={social.name}
                        component="a"
                        href={social.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        sx={{
                          bgcolor: "rgba(255,255,255,0.9)",
                          color: "#0D5DB5", // Primary theme color
                          boxShadow: "0 4px 14px rgba(0, 0, 0, 0.1)",
                          transition: "all 0.3s ease",
                          "&:hover": {
                            bgcolor: "#0EA5E9", // Primary light
                            color: "white",
                            transform: "translateY(-3px)",
                            boxShadow: "0 6px 20px rgba(14, 165, 233, 0.3)",
                          },
                        }}
                        aria-label={social.name}
                      >
                        <svg
                          width="22"
                          height="22"
                          viewBox="0 0 24 24"
                          fill="currentColor"
                        >
                          <path d={social.path} />
                        </svg>
                      </IconButton>
                    ))}
                  </Box>
                </Box>
              </Box>
            </Box>
          </Box>
        </MotionBox>
      </Container>
    </Box>
  );
};

export default CtaBanner;
